import React, { useState } from 'react';
import GetMonths from '../Dropdowns/getMonths';
import GetYears from '../Dropdowns/getYears';
import FPS_Stock_details from './FPS_Stock_details'
const FPS_Stock = ({ heading }) => {

    const [renderContent, setRenderContent] = useState(null);
    const [loading, setLoading] = useState(true); // Manage loading state
    const [value, setValue] = useState('');

    const handleInputChange = (e) => {
        const inputValue = e.target.value.toUpperCase();

        // Allow only alphabets and numbers
        if (/^[A-Z0-9]*$/.test(inputValue)) {
            if (inputValue.length <= 12) {
                setValue(inputValue);
            }
        }
    };

    const handlePaste = (e) => {
        const pasteData = e.clipboardData.getData('text').toUpperCase().replace(/[^A-Z0-9]/g, '');
        if (pasteData.length <= 12) {
            setValue(pasteData);
        }
        e.preventDefault();
    };


    const handleLoadingChange = (isLoading) => {
        setLoading(isLoading);
    };

    const handleSubmit = () => {
        const month = document.getElementById('month').value;
        const year = document.getElementById('year').value;
        const fps_id = document.getElementById('fps_id').value;

        if (month == 0 || month == null || month == '') {
            alert('Please select Month');
        } else if (year == 0 || year == null || year == '') {
            alert('Please select Year');
        } else if (fps_id.length == 0 || fps_id == null || fps_id.trim() == '') {
            alert('Please Enter FPS Id');
        } else {
            setRenderContent(null);

            setTimeout(() => {
                setRenderContent(
                    <FPS_Stock_details
                        month={month}
                        year={year}
                        fps_id={fps_id}
                        heading={heading}
                    />
                );
            }, 0);
        }
    };

    return (
        <>
            <div className="wrapper row3">
                <div id="container">
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <table width="30%">
                            <thead>
                                <tr className="tableheader">
                                    <th colSpan={8}>{heading}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Month</td>
                                    <td><GetMonths onLoadingChange={handleLoadingChange} /></td>
                                    <td>Year</td>
                                    <td><GetYears onLoadingChange={handleLoadingChange} /></td>
                                    <td>FPS </td>
                                    <td><input type="text" onmouseover="this.select()" size="12" maxlength="12" name="fps_id" id="fps_id"
                                        value={value}
                                        onChange={handleInputChange}
                                        onPaste={handlePaste} /></td>
                                </tr>
                                <tr>
                                    <td colSpan={8} align="center">
                                        <button onClick={handleSubmit} className="button button2" disabled={loading}>
                                            Submit
                                        </button>
                                        <button className="button button2">
                                            Back
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <br />
                    <div id="loading" style={{ display: 'none', textAlign: 'center' }}>
                        <img src="images/progress.gif" alt="Loading" />
                    </div>
                    <br />
                    {/* Render the dynamic content here */}
                    <div id="details1">{renderContent}</div>
                </div>
            </div>
        </>
    );
};

export default FPS_Stock;
